import React, {useContext} from 'react';
import {
    _t,
    getSystemSettings,
    getTaxIntegrationDetails,
} from "../../../../../functions/Functions";
import { useCustomHooks } from '../../../../../functions/Hooks';
import { useTranslation } from "react-i18next";
import { SettingsContext } from "../../../../../contexts/Settings";
import { FoodContext } from '../../../../../contexts/Food';
import Moment from "react-moment";
import moment from 'moment';
import QRCode from "react-qr-code";
import { BASE_URL } from '../../../../../BaseUrl';
import { useReceiptTranslation } from '../../../../../hooks/useReceiptTranslation';

const OrderPrintView = ({
    componentRef,
    component2Ref,
    foodGroupsToPrint,
    checkOrderDetails,
    taxPercent,
    isSettle,
    fbrInvoiceNum,
    srbInvoiceNum,
    paidMoney,
    isOnline = 0,
    isSubmitted = 0,
    redeemPoints = null,
    availablePoints = null,
    earnedPoints = null,
}) => {
    const { t } = useTranslation();
    const { generalSettings } = useContext(SettingsContext);
    const { availableFoodGroupName } = useContext(FoodContext);
    const { multiplyAddon, renderNetBill, roundFormatPrice, showPriceOfEachOrderItemPrint, showPropertyPrice } = useCustomHooks();
    const { getDualText, getDualTextValue, getCombination, getDualTextKey, renderItemName, getTranlatedValue } = useReceiptTranslation();
    //print online
    const onlinePayment = (item) =>{
        if(item.payment_method === "Card" || item.payment_method === "Online"){
          return " Online Paid"
        }else if(item.payment_method === "Cash"){
          return " Cash On Delivery"
        }else{
          return " Swipe Card at your Door Step"
        }
    }

    //print payment
    const printPayment = (payment) =>{
        if(typeof(payment) === "string"){
            return payment
        }else{
            const paymentType = payment && payment.map((item) => (item.name || item.payment_type)).join(", ");
            return paymentType
        }
    }

    //print total
    const printTotalPay = (total_payable) =>{
        const vat = checkOrderDetails.item?.vat ? checkOrderDetails.item.vat :
        Math.ceil(
            (parseFloat(taxPercent || checkOrderDetails.item?.tax_percent) / 100) *
            parseFloat(
                checkOrderDetails.item.order_bill
            )
        )
        const total = checkOrderDetails.item?.is_foc ? (Number(total_payable) - Number(vat)) : Number(total_payable); 
        if(isSettle.current === 0 && (checkOrderDetails.item.theBranch?.fbr_integration === 1 || checkOrderDetails.item.theBranch?.pbr_integration === 1 || checkOrderDetails.item.theBranch?.cbr_integration === 1 ||
           checkOrderDetails.item.theBranch?.kpra_integration === 1 || checkOrderDetails.item?.theBranch?.sbr_integration === 1)){
           return roundFormatPrice(total + 1)
        }else{
            return roundFormatPrice(total)
        }
    }

    const qrPrint = (taxTaken,printText,InvoiceNum,taxImage,url="") =>{
      return(
        <div className="mb-1">
            <p className="print-text fk-print-text text-capitalize text-center">
                {taxTaken} Invoice Number# {InvoiceNum}
            </p>
            <div className="mb-1">
                <div className="float-left">
                <img
                    src={taxImage}
                    height="80"
                    alt={`${taxTaken} Invoice`}
                />
                </div>
                <div className="float-right">
                {url && (
                    <QRCode value={url} size="80" />
                )}
                </div>
                <div style={{ clear: "both" }}></div>
            </div>
            <p className="print-text fk-print-text text-center">
              {printText} <br></br> and win exciting prizes in
              draw.
            </p>
        </div>
      )
    }

    const checkRequestOrder = checkOrderDetails.item && (checkOrderDetails.item?.request_from === "POS" ||
        checkOrderDetails.item?.request_from === undefined || checkOrderDetails.item?.request_from === null);

  return (
    <>
        <div className="d-none">
            <div ref={componentRef}>
            {checkOrderDetails && checkOrderDetails.item && (
                <div className="fk-print">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                {
                                    (parseInt(getSystemSettings(generalSettings, "submit_print_header")) === 1 ? true : isSettle.current) ? (
                                        <>
                                            {
                                                parseInt(getSystemSettings(generalSettings, "print_logo")) === 1 && (
                                                <div className="mx-auto t-w-120">
                                                    <img src={(checkOrderDetails.item.theBranch && checkOrderDetails.item.theBranch?.branch_logo) ? (BASE_URL + checkOrderDetails.item.theBranch?.branch_logo) :
                                                        `${getSystemSettings(
                                                        generalSettings,
                                                        "type_logo"
                                                    )}`}
                                                    alt="logo"
                                                    className="w-100"
                                                    />
                                                </div>
                                                ) 
                                            }

                                            {
                                                parseInt(getSystemSettings(generalSettings, "print_siteName")) === 1 && (
                                                    <div className="fk-print-text font-weight-bold text-center sm-text mt-2">
                                                    {getSystemSettings(generalSettings, "siteName")}
                                                    </div>
                                                ) 
                                            }
                                            {
                                                parseInt(getSystemSettings(generalSettings, "print_branchName")) === 1 && (
                                                <div className="fk-print-text font-weight-bold text-uppercase text-center sm-text mt-2">
                                                    {checkOrderDetails.item.theBranch && (checkOrderDetails.item.theBranch?.print_name ? checkOrderDetails.item.theBranch.print_name : checkOrderDetails.item.branch_name)}
                                                </div>
                                                ) 
                                            }  
                                            {
                                                parseInt(getSystemSettings(generalSettings, "print_branchAddress")) === 1 && (
                                                <p className="mb-0 sm-text fk-print-text text-center text-capitalize">
                                                {checkOrderDetails.item?.theBranch &&
                                                checkOrderDetails.item.theBranch.address
                                                    ? checkOrderDetails.item.theBranch.address
                                                    : ""}
                                                </p>
                                                )
                                            }
                                            {
                                                parseInt(getSystemSettings(generalSettings, "print_branchPhone")) === 1 &&(
                                                <p className="mb-0 sm-text fk-print-text text-center text-capitalize">
                                                    {getDualTextValue("call", (checkOrderDetails.item.theBranch?.phn_no && checkOrderDetails.item.theBranch.phn_no) ?? "", ": ")}
                                                </p>
                                                )
                                            }

                                            {
                                                parseInt(getSystemSettings(generalSettings, "print_heading")) === 1 && (
                                                <p className="mb-0 sm-text fk-print-text text-center">
                                                    {(checkOrderDetails.item?.theBranch && checkOrderDetails.item.theBranch?.sntn_no) ? 
                                                    checkOrderDetails.item.theBranch.sntn_no : getSystemSettings(generalSettings, "type_print_heading")}
                                                </p>
                                            )
                                            }
                                        </>
                                    ) : ""
                                }
                                
                                {checkOrderDetails.item?.table_name && checkOrderDetails.item?.table_name !== "-" ? (
                                    <p className="mb-0 sm-text fk-print-text text-capitalize text-center">
                                        {getDualTextValue("Table #", checkOrderDetails.item?.table_name, ": ")}
                                    </p>
                                ) : (
                                    ""
                                )}
                                
                                {
                                    getSystemSettings(generalSettings, "duplicate_print_text") && (isSubmitted ? !isSettle.current : true) ?  (
                                    <p className="mb-0 print-text fk-print-text">
                                        {getSystemSettings(generalSettings, "duplicate_print_text")}
                                    </p>
                                    ) : ""
                                }
                                <div className = "d-flex align-items-center justify-content-between myBorderTopCustomer pt-1"> 
                                    <span className="fk-print-text text-uppercase text-center new-sm-text fk-print-text--bold mr-1">
                                        {getDualTextValue(getSystemSettings(generalSettings, "token_text"), checkOrderDetails.item?.token?.id, " - ")}
                                    </span>

                                    {
                                        parseInt(getSystemSettings(generalSettings, "order_no")) === 1 && (
                                        <span className="fk-print-text text-uppercase text-right new-sm-text fk-print-text--bold ml-1">
                                            {getDualTextValue("Invoice No", checkOrderDetails.item?.order_no ?? "", "- ")}
                                        </span>
                                        )
                                    }
                                </div>  
                                {
                                    getSystemSettings(generalSettings, "print_orderParty") === "both" && (
                                    <p className="mb-0 fk-print-text text-capitalize print-text text-center">
                                        {getCombination(checkOrderDetails.item.order_type_name, checkOrderDetails.item?.party_name)}
                                    </p>
                                    )
                                }
                                {
                                    getSystemSettings(generalSettings, "print_orderParty") === "order_type" && (
                                    <p className="mb-0 fk-print-text text-capitalize print-text text-center">
                                        {getCombination(checkOrderDetails.item.order_type_name)}
                                    </p>
                                    )
                                }
                                {
                                    getSystemSettings(generalSettings, "print_orderParty") === "party" && (
                                    <p className="mb-0 fk-print-text text-capitalize print-text text-center">
                                        {getCombination(checkOrderDetails.item?.party_name)}
                                    </p>
                                    )
                                }
                            
                                <p className="mb-0 mt-0 print-text fk-print-text text-capitalize text-center">
                                    {getDualText("Customer Copy")}
                                </p>

                                <div className="myBorder mb-2"></div>
                                
                                {
                                    checkOrderDetails.item.customer_name &&(
                                    <p className="mb-1 print-text fk-print-text text-capitalize">
                                        {getDualTextValue("Customer Name", checkOrderDetails.item.customer_name, ": ")}
                                    </p>
                                    )
                                }
                                {
                                    checkOrderDetails.item.delivery_phn_no && (
                                    <p className="mb-1 print-text fk-print-text text-capitalize">
                                        {getDualTextValue("Phone #", checkOrderDetails.item.delivery_phn_no, ": ")}
                                    </p>
                                    )
                                }
                                {
                                    checkOrderDetails.item?.alt_phn_no && (
                                    <p className="mb-1 print-text fk-print-text text-capitalize">
                                        {getDualTextValue("Alt Phone #", checkOrderDetails.item?.alt_phn_no, ": ")}
                                    </p>
                                    )
                                }
                                {
                                    (checkOrderDetails.item?.ntn_no) && (
                                    <p className="mb-1 print-text fk-print-text text-capitalize">
                                        {getDualTextValue("NTN No", checkOrderDetails.item?.ntn_no, ": ")}
                                    </p>
                                    )
                                }
                                {
                                    checkOrderDetails.item?.nearest_landmark && (
                                    <p className="mb-1 print-text fk-print-text text-capitalize">
                                        {getDualTextValue("Nearest Landmark", checkOrderDetails.item?.nearest_landmark, ": ")}
                                    </p>
                                    )
                                }
                                {
                                    checkOrderDetails.item?.area_name && (
                                    <p className="mb-1 print-text fk-print-text text-capitalize">
                                        {getDualTextValue("Area Name", checkOrderDetails.item?.area_name, ": ")}
                                    </p>
                                    )
                                }
                                {
                                    checkOrderDetails.item.delivery_address && (
                                    <p className="mb-1 print-text fk-print-text text-capitalize">
                                        {getDualTextValue("Address", checkOrderDetails.item.delivery_address, ": ")}
                                    </p>
                                    )
                                }
                                {
                                    checkOrderDetails.item?.vehicle_no &&(
                                    <p className="mb-1 print-text fk-print-text text-capitalize">
                                        {getDualTextValue("Vehicle No", checkOrderDetails.item.vehicle_no, ": ")}
                                    </p>
                                    )
                                }
                                
                                <p className="mb-1 print-text fk-print-text text-capitalize">
                                    {getDualTextValue("ref no", checkOrderDetails.item?.ref_no ?? "", " : ")}
                                </p>

                                {checkOrderDetails.item.delivery_boy_name && (
                                    <p className="mb-1 print-text fk-print-text text-capitalize">
                                        {getDualTextValue("Rider name", checkOrderDetails.item.delivery_boy_name, " : ")}
                                    </p>
                                )
                                }
                                {checkOrderDetails.item?.note_to_rider && checkOrderDetails.item?.note_to_rider !== "" && 
                                    <p className="mb-1 print-text fk-print-text text-capitalize mx-1">
                                        {getDualText("Rider Note", checkOrderDetails.item.note_to_rider, ": ")}
                                    </p>    
                                }
                                {isOnline ? onlinePayment(checkOrderDetails.item) : ""}
                                {!isOnline && parseInt(getSystemSettings(generalSettings, "print_paymentType")) === 1 && (
                                !checkOrderDetails.settle ? (
                                parseInt(checkOrderDetails.item.is_cancelled) === 0 ? (
                                    parseInt(checkOrderDetails.item.is_paid) === 0 ? (
                                        <p className="mb-0 md-text fk-print-text text-capitalize">
                                            {parseInt(checkOrderDetails.item?.is_foc) ? getDualTextValue("Free Of Cost") : getDualTextValue("Unpaid")}
                                        </p>
                                    ) : (
                                        <p className="mb-0 md-text fk-print-text text-capitalize">
                                            {getDualTextValue("PAID",
                                                checkOrderDetails.item.bill_distribution
                                                ? printPayment(checkOrderDetails.item.bill_distribution)
                                                : "" , " - "
                                            )}
                                            <span className='sm-text'>{checkOrderDetails.item.is_refund ? " (Refund)" : ""}</span>
                                        </p>
                                    )
                                ) : (
                                        <p className="mb-0 md-text fk-print-text text-capitalize">
                                            {getDualTextValue("Cancelled")}
                                        </p>
                                )
                                ) : (
                                ""
                                ))}
                                <p className="mb-1 print-text fk-print-text text-capitalize">
                                    {getDualTextValue("date", moment(checkOrderDetails.item.created_at).format("MMMM DD, YYYY, hh:mm A"), ": ")}
                                </p>
                                {checkOrderDetails.item?.waiter_name && checkOrderDetails.item?.waiter_name !== "-" && (
                                <p className="mb-1 print-text fk-print-text text-capitalize">
                                    {getDualTextValue("waiter name", checkOrderDetails.item?.waiter_name, ": ")}
                                </p>
                                )}
                                {checkOrderDetails.item.order_type_name === "Dine-In" && (
                                    <p className="mb-1 print-text fk-print-text text-capitalize">
                                        {getDualTextValue("guest", checkOrderDetails.item.total_guest, ": ")}
                                    </p>
                                )
                                }
                                {parseInt(getSystemSettings(generalSettings, "print_paymentType")) === 1 && checkOrderDetails?.payment_type && (
                                    <p className="mb-0 print-text fk-print-text text-capitalize lg-text">
                                        {getDualTextValue("Payment Type", printPayment(checkOrderDetails.payment_type), " - ")}
                                    </p>
                                )}

                                <table className="w-100 mb-0 table-borderless">
                                <thead>
                                    <tr>
                                    <th
                                    scope="col"
                                    className="fk-print-text print-text text-capitalize "
                                    >
                                        <div className="d-flex flex-wrap align-items-center">
                                            <span style={{width:"12%"}} className="fk-print-text d-inline-block">
                                                {getDualText("qty")}
                                            </span>
                                            <span style={{width:"82%"}} className="text-preline text-break fk-print-text d-inline-block ml-2">
                                                {getDualText("item")}
                                            </span>
                                        </div>
                                    </th>
                                    <th
                                    scope="col"
                                    className="fk-print-text print-text text-capitalize text-right"
                                    >      
                                        {getDualText("T.price")}
                                    </th>
                                    </tr>
                                </thead>
                                <tr className="myBorderBottom mb-1"></tr>
                                <tbody>
                                    {checkOrderDetails.item &&
                                    checkOrderDetails.item.orderedItems.map(
                                        (thisItem, indexThisItem) => {
                                        return (
                                            <>
                                            <tr key={indexThisItem}>
                                                <td className="fk-print-text print-text text-capitalize">
                                                <div className="d-flex flex-wrap align-items-center">
                                                <span style={{width:"12%"}} className="fk-print-text d-inline-block">
                                                    {Number(thisItem.quantity)}{" "}
                                                </span>
                                                <span style={{width:"82%"}} className="text-preline text-break fk-print-text d-inline-block ml-2">
                                                    {renderItemName(thisItem, false, false)}
                                                </span>
                                                </div>
                                                </td>
                                                <td className="fk-print-text print-text text-capitalize text-right">
                                                    {showPriceOfEachOrderItemPrint(thisItem, taxPercent || checkOrderDetails.item.theBranch?.branch_tax, checkRequestOrder)}
                                                </td>
                                                </tr>
                                                {/* properties */}
                                                {thisItem.properties !== null && 
                                                JSON.parse(thisItem.properties).map(
                                                    (propertyItem, thisIndex) => {
                                                    const shouldMultiply = multiplyAddon || checkRequestOrder;
                                                    const mainQty = shouldMultiply ? thisItem.quantity : "";
                                                    const propertyQty = shouldMultiply ? (propertyItem.quantity > 1
                                                        ? "*" + propertyItem.quantity : "") : propertyItem.quantity;

                                                    return (
                                                        <tr key={thisIndex}>
                                                            <td className="fk-print-text print-text text-capitalize">
                                                            <span className="fk-print-text text-capitalize print-text d-inline-block mr-1 " style={{marginLeft:"14%"}}>
                                                                {getTranlatedValue(`-${mainQty}${propertyQty} ${propertyItem.property}`, propertyItem?.translated_name && `  ${propertyItem?.translated_name}`)}
                                                            </span>
                                                            </td>
                                                            <td className="fk-print-text print-text text-capitalize text-right">
                                                                {(thisItem.status === "foc" || thisItem.status === "complimentory") && thisItem.after_tax_price == 0 ?
                                                                  0 : showPropertyPrice(
                                                                    shouldMultiply ? (thisItem.quantity * propertyItem.quantity) : propertyItem.quantity,
                                                                    propertyItem.price_per_qty,
                                                                    taxPercent || checkOrderDetails.item.theBranch.branch_tax
                                                                )}
                                                            </td>
                                                        </tr>
                                                    );
                                                    }
                                                )}
                                            </>
                                        );
                                        }
                                    )}
                                </tbody>
                                </table>

                                <div className="myBorder mb-1"></div>
                                <table className="w-100 mb-0 table-borderless">
                                    <tbody>
                                        <tr>
                                        <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                            {getDualTextValue("total")}
                                        </th>
                                        <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                            {roundFormatPrice(checkOrderDetails.item.order_bill)}
                                        </td>
                                        </tr>
                                    </tbody>
                                </table>

                                {!parseInt(checkOrderDetails.item?.is_foc) && parseFloat(checkOrderDetails.item.vat) > 0 && (
                                <table className="w-100 mb-0 table-borderless">
                                    <tbody>
                                    {checkOrderDetails.item.vat_system === "igst" ? (
                                        <tr>
                                        <th className="py-0 pb-1 fk-print-text print-text text-uppercase">
                                            {getDualTextKey(checkOrderDetails.item.theBranch?.print_tax, taxPercent > 0
                                                ? "(" + taxPercent + `%)`
                                              : "(" + (checkOrderDetails.item?.tax_percent || checkOrderDetails.item.theBranch?.branch_tax) + `%)`)}
                                        </th>
                                        <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                            {roundFormatPrice(
                                                checkOrderDetails.item?.vat ? checkOrderDetails.item.vat :
                                                Math.ceil(
                                                    (parseFloat(taxPercent) / 100) *
                                                    parseFloat(
                                                        checkOrderDetails.item.order_bill
                                                    )
                                                )
                                            )}
                                        </td>
                                        </tr>
                                    ) : (
                                        <>
                                        <tr>
                                            <th className="py-0 pb-1 fk-print-text print-text">
                                            CGST
                                            </th>
                                            <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                            {roundFormatPrice(
                                                parseFloat(checkOrderDetails.item.cgst)
                                            )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th className="py-0 pb-1 fk-print-text print-text">
                                            SGST
                                            </th>
                                            <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                            {roundFormatPrice(
                                                parseFloat(checkOrderDetails.item.sgst)
                                            )}
                                            </td>
                                        </tr>
                                        </>
                                    )}
                                    </tbody>
                                </table>
                                )}
                                {getSystemSettings(generalSettings, "sDiscount") ===
                                "flat" && (
                                <>
                                    {parseFloat(checkOrderDetails.item.service_charge) > 0 && (
                                    <table className="w-100 mb-0 table-borderless">
                                        <tbody>
                                        <tr>
                                            <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                                {getDualText("D.Charge")}
                                            </th>

                                            <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                            {roundFormatPrice(
                                                checkOrderDetails.item.service_charge
                                            )}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    )}
                                    {checkOrderDetails.item.service_amount &&
                                    parseFloat(checkOrderDetails.item.service_amount) > 0 ? (
                                    <table className="w-100 mb-0 table-borderless">
                                    <tbody>
                                    <tr>
                                        <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                            {getDualText("S.Charges")}
                                            {`(${checkOrderDetails.item.theBranch.service_fees}%)`}
                                        </th>
                                        <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                        {checkOrderDetails.item.service_amount
                                            ? roundFormatPrice(
                                                parseFloat(checkOrderDetails.item.service_amount)
                                            )
                                            : 0}
                                        </td>
                                    </tr>
                                    </tbody>
                                    </table>
                                    ) : null}
                                    {parseFloat(checkOrderDetails.item.discount) > 0 ||
                                    parseFloat(checkOrderDetails.item.discount_amount) > 0 ? (
                                        <>
                                        <table className="w-100 mb-0 table-borderless">
                                            <tbody>
                                            <tr>
                                                <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                                    {getDualTextKey("discount", (
                                                        checkOrderDetails &&
                                                        checkOrderDetails.item.scheme_id && parseFloat(checkOrderDetails.item.discount) > 0 ?
                                                        `(${parseFloat(checkOrderDetails.item.discount)}%)` : ""
                                                    )
                                                    )}
                                                </th>
                                                <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                                {roundFormatPrice(
                                                    checkOrderDetails.item.discount_amount
                                                )}
                                                </td>
                                            </tr>
                                            {
                                                checkOrderDetails?.item && checkOrderDetails.item?.scheme_name ? (
                                                    <tr>
                                                        <td className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                                        <span className="sm-text">
                                                            {checkOrderDetails.item.scheme_name}
                                                        </span>
                                                        </td>
                                                        <td className="py-0 pb-1">
                                                        </td>
                                                    </tr>
                                                ) : ""
                                            }
                                            </tbody>
                                        </table>
                                        </>
                                    ) : null}
                                </>
                                )}

                                {getSystemSettings(generalSettings, "sDiscount") ===
                                "percentage" && (
                                <>
                                    {parseFloat(checkOrderDetails.item.service_charge) > 0 && (
                                    <table className="w-100 mb-0 table-borderless">
                                        <tbody>
                                        <tr>
                                            <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                                {getDualText("D.Charge")}
                                                {checkOrderDetails.item &&
                                                "(" +
                                                    checkOrderDetails.item.service_charge +
                                                    "%)"}
                                            </th>

                                            <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                            {roundFormatPrice(
                                                checkOrderDetails.item.order_bill *
                                                (checkOrderDetails.item.service_charge / 100)
                                            )}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    )}
                                    {checkOrderDetails.item.service_amount &&
                                    parseFloat(checkOrderDetails.item.service_amount) > 0 ? (
                                        <table className="w-100 mb-0 table-borderless">
                                        <tbody> 
                                        <tr>
                                            <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                                {getDualText("S.Charges Optional")}
                                                {`(${checkOrderDetails.item.theBranch.service_fees}%)`}
                                            </th>
                                            <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                            {checkOrderDetails.item.service_amount
                                                ? roundFormatPrice(
                                                    parseFloat(checkOrderDetails.item.service_amount)
                                                )
                                                : 0}
                                            </td>
                                        </tr>
                                        </tbody>
                                        </table>
                                    ) : null}

                                    {parseFloat(checkOrderDetails.item.discount) > 0 ||
                                    parseFloat(checkOrderDetails.item.discount_amount) >
                                    0 ? (
                                    <table className="w-100 mb-0 table-borderless">
                                        <tbody>
                                        <tr>
                                            <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                                {getDualTextKey("discount", (
                                                    checkOrderDetails.item && parseFloat(checkOrderDetails.item.discount) > 0 &&
                                                    "(" +
                                                        checkOrderDetails.item.discount +
                                                        "%)"
                                                ))}
                                            </th>
                                            <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                            {roundFormatPrice(
                                                checkOrderDetails.item.discount_amount
                                            )}
                                            </td>
                                        </tr>
                                        {
                                            checkOrderDetails?.item && checkOrderDetails.item?.scheme_name ? (
                                                <tr>
                                                    <td className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                                    <span className="sm-text">
                                                        {checkOrderDetails.item.scheme_name}
                                                    </span>
                                                    </td>
                                                    <td className="py-0 pb-1">
                                                    </td>
                                                </tr>
                                            ) : ""
                                        }
                                        </tbody>
                                    </table>
                                    ) : null}
                                </>
                                )}

                                {redeemPoints && Number(redeemPoints) > 0 ? (
                                    <table className="w-100 mb-0 table-borderless">
                                        <tbody>
                                        <tr>
                                            <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                                {getDualText("Redeem Points")}
                                            </th>
                                            <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                                {roundFormatPrice(redeemPoints)}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                ) : ""
                                }
                            
                                {checkOrderDetails?.payment_type && checkOrderDetails.payment_type?.length > 1 && (
                                <>
                                    <div className="myBorder mb-1"></div>
                                    <table className="w-100 mb-0 table-borderless">
                                    <tbody>
                                        {checkOrderDetails?.payment_type.map((item, index)=>{
                                            return (
                                            <tr key={index}>
                                                <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                                    {_t(t(item.name))}
                                                </th>
                                                <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                                    {_t(t(item.bill_amount))}
                                                </td>
                                            </tr>
                                            )
                                        }) 
                                        }
                                    </tbody>
                                    </table>
                                </>
                                )}
                                <div className="myBorder mb-1"></div>
                                <table className="w-100 mb-0 table-borderless">
                                    <tbody>
                                        {((checkOrderDetails.item.theBranch?.fbr_integration === 1 || checkOrderDetails.item.theBranch?.pbr_integration === 1 || 
                                        checkOrderDetails.item?.theBranch?.sbr_integration === 1) || checkOrderDetails.item.theBranch?.kpra_integration === 1
                                        || checkOrderDetails.item.theBranch?.cbr_integration === 1) &&
                                        (isSettle.current === 0 ? true : (fbrInvoiceNum || srbInvoiceNum?.number)) ? (
                                        <tr>
                                            <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                                {getDualText("POS Invoice Fee")}
                                            </th>
                                            <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                                {_t(t("1.00"))}
                                            </td>
                                        </tr>
                                        ) : null}
                                        {checkOrderDetails.item.is_advance_booking && Number(checkOrderDetails.item?.advance_payment) > 0 ? (
                                            <tr>
                                                <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                                {getDualText("Advance Amount")}
                                                </th>
                                                <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                                {roundFormatPrice(checkOrderDetails.item.advance_payment)}
                                                </td>
                                            </tr>
                                        ) : ""
                                        }
                                        <tr>
                                            <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                                {getDualText(checkOrderDetails.item.is_advance_booking && Number(checkOrderDetails.item?.advance_payment) > 0 ? "Remaining Amount": "grand total")}
                                            </th>
                                            <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                                {printTotalPay(checkOrderDetails.item.total_payable)}
                                            </td>
                                        </tr>
                                        <tr>
                                        {checkOrderDetails.item.is_refund === 1 ? (
                                            <>
                                            <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                                {getDualText("Refund Amount")}
                                            </th>
                                            <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                                {roundFormatPrice(
                                                checkOrderDetails.item.paid_amount
                                                )}
                                            </td>
                                            </>
                                        ) : checkOrderDetails.item.is_foc === 1 ? (
                                        <>
                                        </>
                                        ) : (
                                        <>
                                            <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                                {getDualText("Paid Amount")}
                                            </th>
                                            <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                                {roundFormatPrice(
                                                checkOrderDetails.settle
                                                    ? (paidMoney)
                                                    : (checkOrderDetails.item.paid_amount || 0)
                                                )}
                                            </td>
                                        </>
                                        )}
                                        </tr>

                                        <tr>
                                            <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                                {getDualText("Return Amount")}
                                            </th>
                                            <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                                {(checkOrderDetails.settle
                                                ? paidMoney
                                                : checkOrderDetails.item.paid_amount) -
                                                parseFloat(checkOrderDetails.item.total_payable) >
                                                0
                                                ? roundFormatPrice(
                                                    (checkOrderDetails.settle
                                                        ? paidMoney
                                                        : checkOrderDetails.item.paid_amount) -
                                                        parseFloat(checkOrderDetails.item.total_payable)
                                                    )
                                                : roundFormatPrice(0)}
                                            </td>
                                        </tr>
                                        {
                                            Number(checkOrderDetails.item?.order_tip) > 0 && (
                                                <tr>
                                                    <th className="pb-1 fk-print-text print-text text-capitalize">
                                                        {getDualText("Order Tip")}
                                                    </th>
                                                    <td className="pb-1 fk-print-text print-text text-capitalize text-right">
                                                        {roundFormatPrice(checkOrderDetails.item.order_tip)}
                                                    </td>
                                                </tr>
                                            )
                                        }
                                        {availablePoints && Number(availablePoints) > 0 ? (
                                            <tr>
                                                <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                                    {getDualText("Available Points")}
                                                </th>
                                                <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                                    {roundFormatPrice(availablePoints)}
                                                </td>
                                            </tr>
                                            ) : ""
                                        }
                                        {earnedPoints && Number(earnedPoints) > 0 ? (
                                            <tr>
                                                <th className="py-0 pb-1 fk-print-text print-text text-capitalize">
                                                    {getDualText("Earned Points")}
                                                </th>
                                                <td className="py-0 pb-1 fk-print-text print-text text-capitalize text-right">
                                                    {roundFormatPrice(earnedPoints)}
                                                </td>
                                            </tr>
                                            ) : ""
                                        }
                                    </tbody>
                                </table>
                                {parseInt(getSystemSettings(generalSettings, "fixed_inclusive_tax")) !== 1 && parseInt(getSystemSettings(generalSettings,"view_cash_card")) === 1 &&  !isSettle.current && (
                                <React.Fragment>
                                    <div className="myBorder mt-1"></div>
                                    {renderNetBill(printTotalPay(checkOrderDetails.item.total_payable),checkOrderDetails.item.order_bill, checkOrderDetails.item.vat, checkOrderDetails.item?.discount_amount, checkOrderDetails.item, "cash", "Cash Net Bill")}
                                    
                                    {renderNetBill(printTotalPay(checkOrderDetails.item.total_payable), checkOrderDetails.item.order_bill, checkOrderDetails.item.vat, checkOrderDetails.item?.discount_amount, checkOrderDetails.item, "card", "Card Net Bill")}
                                </React.Fragment>  
                                )
                                }

                                {(() => {
                                  const taxDetails = getTaxIntegrationDetails(checkOrderDetails.item.theBranch, fbrInvoiceNum, srbInvoiceNum?.number, srbInvoiceNum?.url);
                                  if (taxDetails) {
                                    const invNum = fbrInvoiceNum || (srbInvoiceNum?.number);
                                    return qrPrint(taxDetails.taxTaken, taxDetails.printText, invNum, taxDetails.taxImage, taxDetails.qrValue);
                                  }
                                  return null;
                                })()}
                                
                                {
                                    checkOrderDetails.item?.id && (checkOrderDetails.item.theBranch?.feedback_url || 
                                        (parseInt(getSystemSettings(generalSettings, "is_feedback")) === 1 && checkOrderDetails.item?.hashId)) ? (
                                        <>
                                            <div className="myBorder mt-1"></div>
                                            <div className="text-center mt-2" style={{ transform: 'scale(0.85)', transformOrigin: 'center center'}}>
                                                {parseInt(getSystemSettings(generalSettings, "is_feedback")) === 1 ? (
                                                    checkOrderDetails.item?.hashId && (<QRCode value={window.location.origin + "/feedback/" + checkOrderDetails.item?.hashId} size="116"/>)
                                                  ) : (
                                                    checkOrderDetails.item.theBranch?.feedback_url && (
                                                        <QRCode value={checkOrderDetails.item.theBranch?.feedback_url + "?uid=" + checkOrderDetails.item.id} size="116"/>
                                                    )
                                                )}
                                            </div>
                                            <div style={{ clear: "both" }}></div>
                                            <p className="print-text fk-print-text text-center my-1">
                                                {getDualText("Your Feedback Feeds Our Improvement – Scan to Help!")}
                                            </p>
                                        </>
                                    ) : ""
                                }
                            
                                <div className="myBorder"></div>
                                <p className="text-preline my-0 sm-text fk-print-text text-center text-capitalize">
                                {getSystemSettings(generalSettings, "type_print_footer")}
                                </p>
                                <p className="my-0 sm-text fk-print-text text-capitalize text-center">
                                {_t(t("bill prepared by"))}:{" "}
                                {checkOrderDetails.item &&
                                    checkOrderDetails.item.user_name}
                                </p>
                                <p className="my-0 sm-text fk-print-text text-capitalize text-center">
                                    {_t(t(getSystemSettings(generalSettings, "print_bill_footer")))}
                                </p>
                                <p className="my-0 fk-print-text text-capitalize print-text fk-print-text--bold">
                                    {_t(t("Print Time"))}: {" "}
                                    {checkOrderDetails?.item && (
                                        <Moment format="LLL">{new Date()}</Moment>
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            </div>
        </div>

        {/* Print bill kitchen */}
        <div className="d-none">
            <div ref={component2Ref}>
            {checkOrderDetails && (
                <div className="fk-print">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 mt-3">
                                <div className = "d-flex align-items-center justify-content-between"> 
                                <span className="fk-print-text text-uppercase lg-text fk-print-text--bold mr-1">
                                    {getDualTextValue(getSystemSettings(generalSettings, "token_text"), (checkOrderDetails.item && checkOrderDetails.item.token.id) ?? "", " - ")}
                                </span>

                                {parseInt(getSystemSettings(generalSettings, "order_no")) === 1 && (
                                    <span className="fk-print-text text-uppercase text-right lg-text fk-print-text--bold ml-1">
                                        {getDualTextValue("Invoice No", checkOrderDetails.item?.order_no ?? "", " - ")}
                                    </span>
                                    )
                                }
                                </div>

                                {checkOrderDetails.item && checkOrderDetails.item?.customer_name && (
                                    <p className="mb-0 fk-print-text text-capitalize text-center lg-text fk-print-text--bold">
                                        {getDualTextValue("Customer Name", checkOrderDetails.item?.customer_name ?? "", ": ")}
                                    </p>
                                )}

                                {checkOrderDetails.item && checkOrderDetails.item?.table_name && (
                                    <p className="mb-0 fk-print-text text-capitalize text-center lg-text fk-print-text--bold">
                                        {getDualTextValue("Table #", checkOrderDetails.item?.table_name ?? "", ": ")}
                                    </p>
                                )}

                                {checkOrderDetails.item?.waiter_name && checkOrderDetails.item?.waiter_name !== "-" && (
                                    <p className="mb-0 fk-print-text text-capitalize text-center lg-text fk-print-text--bold">
                                        {getDualTextValue("waiter name", checkOrderDetails.item?.waiter_name, ": ")}
                                    </p>
                                )}

                                {
                                    checkOrderDetails.item?.vehicle_no && (
                                    <p className="mb-1 print-text fk-print-text text-center text-capitalize">
                                        {getDualTextValue("Vehicle No", checkOrderDetails.item.vehicle_no, ": ")}
                                    </p>
                                    )
                                }

                                {checkOrderDetails.item && checkOrderDetails.item?.delivery_boy_name && (
                                    <p className="mb-0 fk-print-text text-capitalize text-center lg-text fk-print-text--bold">
                                        {getDualTextValue("Rider Name", checkOrderDetails.item?.delivery_boy_name ?? "", " : ")}
                                    </p>
                                )}
                                
                                {
                                    (checkOrderDetails.item?.is_cancelled || checkOrderDetails.item?.is_refund) && (
                                        <p className="mb-0 fk-print-text text-capitalize text-center lg-text fk-print-text--bold">
                                            {getDualText((checkOrderDetails.item && checkOrderDetails.item?.is_cancelled) ? "CANCELLED ORDER" : "REFUND ORDER")}
                                        </p>
                                    )
                                }

                                <p className="mb-0 mt-0 fk-print-text text-capitalize text-center fk-print-text--bold myBorderBottom">
                                    {getDualText(getSystemSettings(generalSettings, "kot_header"))}
                                    {foodGroupsToPrint &&
                                    Object.values(foodGroupsToPrint)?.length &&
                                    Object.values(foodGroupsToPrint)[0][0] &&
                                    Object.values(foodGroupsToPrint)[0][0]?.kot &&
                                    Object.values(foodGroupsToPrint)[0][0].kot !== "No" ? (
                                        <span>
                                        {" "}
                                        ({_t(t(Object.values(foodGroupsToPrint)[0][0].kot))})
                                        </span>
                                    ) : (
                                        ""
                                    )}
                                </p>

                                <table className="w-100 m-0 p-0 table-borderless">
                                    <tr className="myBorderPrintBottom mb-1">
                                        <th
                                        className="fk-print-text text-capitalize"
                                        >
                                        <div className="d-flex flex-wrap">
                                            <span className="d-inline-block lg-text fk-print-text--bold fk-print-text print_w-20" >
                                                {getDualText("Qty")}
                                            </span>
                                    
                                            <span className="d-inline-block lg-text fk-print-text--bold fk-print-text print_w-80" >
                                                {getDualText("Item")}
                                            </span> 
                                        </div>
                                        </th>
                                    </tr>
                                    <tbody>
                                        {foodGroupsToPrint &&
                                        Object.keys(foodGroupsToPrint)?.length &&
                                        Object.keys(foodGroupsToPrint).map(
                                        (theGrp, grpIndex) => {
                                            return (
                                            <>
                                                <tr key={grpIndex}>
                                                <td className="text-center">
                                                    <div
                                                    className={`${
                                                        // grpIndex === 0
                                                        // ? 
                                                        "myBorder"
                                                        // : "myBorderBottom"
                                                    } lg-text fk-print-text--bold fk-print-text mb-1`}
                                                    >
                                                        {getTranlatedValue(theGrp, availableFoodGroupName[theGrp]?.translated_name)}
                                                    </div>
                                                </td>
                                                </tr>
                                            
                                                {foodGroupsToPrint[theGrp].map((printItem) => {
                                                    return (
                                                    <> 
                                                        <tr className="">
                                                        <th className="fk-print-text text-capitalize">
                                                            {(printItem.status || printItem.reason) ? (
                                                            <div className="d-block w-100 p-0 mb-1">
                                                                <span className="lg-text fk-print-text--bold fk-print-text pl-1">
                                                                {printItem.status ? getDualText("CANCELLED") : getDualText("REFUND")}
                                                                </span>
                                                                {":"}
                                                                <span className="lg-text fk-print-text--bold fk-print-text pl-1">
                                                                {" "}
                                                                ({printItem.status})
                                                                {":"}
                                                                </span>
                                                                {printItem.reason ? (
                                                                <span className="lg-text fk-print-text--bold fk-print-text pl-1">
                                                                    {" "}
                                                                    (Reason: {printItem.reason})
                                                                </span>
                                                                ) : null}
                                                            </div>
                                                            ) : null}
                                                            {printItem?.is_special != "1" || !printItem.hasOwnProperty('property') ? (
                                                            <>
                                                                <div className="d-flex flex-wrap">
                                                                    <span className="print_w-20 ml-1 pl-1">
                                                                        {Number(printItem.quantity)}
                                                                    </span>
                                                                    {/* <span className="lg-text fk-print-text--bold fk-print-text print_w-80 p-0 m-0">
                                                                        {printItem.food_item}{" "}
                                                                        {printItem.variation && (
                                                                            <span className="lg-text fk-print-text--bold fk-print-text mr-1" >
                                                                                ({printItem.variation})
                                                                            </span>
                                                                        )}
                                                                    </span> */}
                                                                    {renderItemName(printItem, false, false)}
                                                                    {checkOrderDetails.item?.order_status === "selforder" && (
                                                                        <span className='fk-sm-card__title ml-1'> (<Moment format="hh:mm A">{new Date(printItem.created_at)}</Moment>)</span>
                                                                    )}
                                                                    {/* <span className="text-preline text-break table-text fk-print-text--bold fk-print-text pl-1 ml-2" >
                                                                        {printItem.comments ? `(${printItem.comments})` : ""}
                                                                    </span> */}
                                                                
                                                                </div>
                                                                {/* properties */}
                                                                {printItem.properties !== "" && (
                                                                <div className="d-block">
                                                                    {JSON.parse(printItem.properties).map(
                                                                    (propertyItem, thisIndex) => {
                                                                        const shouldMultiply = multiplyAddon || checkRequestOrder;
                                                                        const mainQty = shouldMultiply ? printItem.quantity : "";
                                                                        const propertyQty = shouldMultiply ? (propertyItem.quantity > 1
                                                                            ? "*" + propertyItem.quantity : "") : propertyItem.quantity;

                                                                        if (
                                                                        thisIndex !==
                                                                        JSON.parse(printItem.properties).length - 1
                                                                        ) {
                                                                        return (
                                                                            <div
                                                                            className="d-flex flex-wrap text-capitalize align-items-center mb-1"
                                                                            >
                                                                            <span className="print_w-20"></span>
                                                                            <span className="text-capitalize print_font d-inline-block mr-1 fk-print-text--bold print_w-80" >
                                                                            {/* ({(multiplyAddon || checkRequestOrder) ?  printItem.quantity : ""}
                                                                                {(multiplyAddon || checkRequestOrder) ? (propertyItem.quantity > 1
                                                                                ? "*" +
                                                                                    propertyItem.quantity
                                                                                : "") : propertyItem.quantity}){" "}
                                                                                {propertyItem.property} */}
                                                                                {getTranlatedValue(`(${mainQty}${propertyQty})  
                                                                                    ${propertyItem.property}`, propertyItem?.translated_name && `  ${propertyItem?.translated_name}`)}
                                                                            </span>
                                                                            </div>
                                                                        );
                                                                        } else {
                                                                        return (
                                                                            <div
                                                                            className="d-flex flex-wrap align-items-center mb-1"
                                                                            >
                                                                            <span className="print_w-20"></span>
                                                                            <span className="text-capitalize print_font d-inline-block mr-1 fk-print-text--bold print_w-80" >
                                                                                {/* ({(multiplyAddon || checkRequestOrder) ? printItem.quantity : ""}
                                                                                {(multiplyAddon || checkRequestOrder) ? (propertyItem.quantity > 1
                                                                                ? "*" +
                                                                                    propertyItem.quantity
                                                                                : "") : propertyItem.quantity}){" "}
                                                                                {propertyItem.property} */}
                                                                                {getTranlatedValue(`(${mainQty}${propertyQty})  
                                                                                    ${propertyItem.property}`, propertyItem?.translated_name && `  ${propertyItem?.translated_name}`) }
                                                                            </span>
                                                                            </div>
                                                                        );
                                                                        }
                                                                    }
                                                                    )}
                                                                </div>
                                                                )}
                                                            </>
                                                            ) : (
                                                            <div>                                              
                                                                <div className="d-flex flex-wrap align-items-center">
                                                                <span className="text-preline text-break print_w-20 ml-1 pl-1">
                                                                    {(multiplyAddon || checkRequestOrder) ? (printItem.quantity * printItem.property.quantity) : printItem.property.quantity}
                                                                    </span>
                                                                    <span className="lg-text fk-print-text--bold fk-print-text print_w-80 p-0 m-0">
                                                                    {printItem.property.property}{" "}
                                                                    
                                                                    <span className="lg-text fk-print-text--bold fk-print-text pl-1 ml-2" >
                                                                    {printItem.comments ? `(${printItem.comments})` : ""}
                                                                    </span>
                                                                    {checkOrderDetails.item?.order_status === "selforder" && (
                                                                        <span className='fk-sm-card__title ml-1'> (<Moment format="hh:mm A">{new Date(printItem.created_at)}</Moment>)</span>
                                                                    )}
                                                                    </span>
                                                                </div>
                                                            </div> 
                                                            )
                                                        }
                                                        </th>
                                                        </tr>
                                                    </>
                                                    );
                                                }
                                                )}
                                            </>
                                            );
                                        }
                                        )}
                                    </tbody>
                                </table>
                                <div className="myBorderBottom"></div>
                                <p className="my-1 print-text fk-print-text text-capitalize lg-text fk-print-text--bold">
                                    {getDualTextValue("Date", moment(new Date()).format("MMMM DD, YYYY, hh:mm A"), ": ")}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            </div>
        </div>
    </>
  )
}

export default OrderPrintView